import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { portfolioAssetClassesURL } from "../request/getPortfolioAssetClasses";
import { portfolioPlanByIdURL } from "../request/getPortfolioPlanById";
import { portfolioPlanByIdPublicURL } from "../request/getPortfolioPlanByIdPublic";
import { portfolioPlanFamilyPathURL } from "../request/getPortfolioPlanFamilyPath";
import { portfolioPlanURL } from "../request/getPortfolioPlans";
import { postPortfoliosPlansBatch, } from "../request/postPortfolioPlansBatch";
import { ALL_PORTFOLIOS } from "./constants";
import { assetClassesKeyMaker } from "./useGetAssetClasses";
const usePostPortfolioPlansBatch = (config) => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (data) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postPortfoliosPlansBatch(data, config);
        },
        onSuccess: (result, { dryRun }) => {
            // We can return a validation error and that should not cause a reset
            // only invalidate if its not a dry run, dry run does not persist any data, it just does a validation check on the incoming data
            if (result.success && dryRun === false) {
                queryClient.invalidateQueries({
                    predicate: (query) => query?.queryKey?.[0] === portfolioPlanURL(),
                });
                // invalidate all fetched portfolios by id
                queryClient.invalidateQueries({
                    predicate: (query) => query?.queryKey?.[0] === portfolioPlanByIdURL(ALL_PORTFOLIOS),
                });
                // invalidate all "public" fetched portfolios by id
                queryClient.invalidateQueries({
                    predicate: (query) => query?.queryKey?.[0] === portfolioPlanByIdPublicURL(ALL_PORTFOLIOS),
                });
                // invalidate all fetched portfolio family path names
                queryClient.invalidateQueries({
                    predicate: (query) => query?.queryKey?.[0] === portfolioPlanFamilyPathURL(ALL_PORTFOLIOS),
                });
                // invalidate all fetched portfolio asset classes (asset class mappings per portfolio)
                queryClient.invalidateQueries({
                    predicate: (query) => query?.queryKey?.[0] === portfolioAssetClassesURL(ALL_PORTFOLIOS),
                });
                // invalidate asset classes - used when making portfolios with asset classes
                if (config !== null) {
                    queryClient.invalidateQueries({
                        queryKey: assetClassesKeyMaker(config.advisorId),
                    });
                }
            }
        },
    });
    return mutation;
};
export default usePostPortfolioPlansBatch;
//# sourceMappingURL=usePostPortfolioPlansBatch.js.map